import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import topicData from '../helpers/state/topic-data';

@customElement('booking-card-component')
export class BookingCardComponent extends LitElement {
    static amplitude_callsite: string = 'Booking Card Component';

    @property({ type: String })
    type: string = '';

    @property({ type: String })
    name: string = '';

    @property({ type: String })
    image: string = '';

    @property({ type: String })
    description: string = '';

    @property({ type: Array })
    experienceTags: string[] = [];

    @property({ type: String })
    price: string = '';

    @property({ type: Number })
    rating: number = 5;

    @property({ type: Number })
    numReviews: number = 0;

    @property({ type: String })
    link: string = '';

    render() {
        return html`
            <a href="${this.link ?? ''}" target=${topicData.topic?.open_links_in_same_tab === true ? '_self' : '_blank'}>
                <div class="card">
                    <h4 class="smallTitle">${this.name.length > 40 ? `${this.name.slice(0,40)}...` : this.name}</h4>
                    <p><b>$${this.price}</b> <br> ${this.numReviews} Reviews | ${this.rating} Stars </p>
                </div>
            </a>
            <error-toast id="errorToast"></error-toast>
        `;
    }


    static get styles() {
        return css`
            :host {
                display: block;
            }

            .card {
                border-radius: 10px;
                border: 1px solid #e5e5e5;
                padding: 10px;
                width: 150px;
                height: 75px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
            }

            a:-webkit-any-link {
                color: inherit;
                cursor: pointer;
                text-decoration: none;
            }

            p {
                margin-top: 4px;
                margin-bottom: 0;
                font-size: 0.7rem;
            }

            .actions {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            .smallTitle {
                font-size: 0.8rem;
                margin: 0;
            }
        `;
    }
}
